module.exports = __webpack_public_path__ + "img/stock5.5fc78668.png";